import makeApiRequest from './makeApiCall';

export const getAllBranches = async (id) => {
  return await makeApiRequest(
    `/collections/all_branches/` + id,
    'GET',
    null,
    null,
    false,
  );
};

export const deleteBankBranches = async (data) => {
  return await makeApiRequest(
    `/collections/bank-branches/trash`,
    'DELETE',
    null,
    data,
    false,
  );
};

export const getBankBranchDetails = async (id) => {
  return await makeApiRequest(
    `/collections/bank-branch/` + id,
    'GET',
    null,
    null,
    false,
  );
};

export const updateBankBranch = async (data) => {
  return await makeApiRequest(
    `/collections/bank-branch-update/` + data.bank_branches_id,
    'PUT',
    null,
    data,
    false,
  );
};

export const bulkPostBranches = async (data) => {
  return await makeApiRequest(
    `/collections/bank-branches/bulk`,
    'POST',
    null,
    data,
    false,
  );
};
export const getBankLists = async (data) => {
  return await makeApiRequest(`/collections/banks`, 'GET', null, data, false);
};

export const bulkPostBanks = async (data) => {
  return await makeApiRequest(
    `/collections/banks-bulk-create`,
    'POST',
    null,
    data,
    false,
  );
};

export const deleteBanks = async (data) => {
  return await makeApiRequest(
    `/collections/banks/trash`,
    'DELETE',
    null,
    data,
    false,
  );
};

export const getAccounts = async (id) => {
  return await makeApiRequest(
    `/collections/bank-accounts/${id}`,
    'GET',
    null,
    null,
    false,
  );
};

export const bulkCreateAccounts = async (data) => {
  return await makeApiRequest(
    `/collections/banks-account-create`,
    'POST',
    null,
    data,
    false,
  );
};

export const deleteAccounts = async (data) => {
  return await makeApiRequest(
    `/collections/bank-accounts/trash`,
    'DELETE',
    null,
    data,
    false,
  );
};

export const updateBanks = async (data, id) => {
  return await makeApiRequest(
    `/collections/bank-update/` + id,
    'PUT',
    null,
    data,
    false,
  );
};

export const updateAccount = async (data, id) => {
  return await makeApiRequest(
    `/collections/bank-account-update/` + id,
    'PUT',
    null,
    data,
    false,
  );
};

export const getAccountDetails = async (id) => {
  return await makeApiRequest(
    `/collections/bank-account-show/` + id,
    'GET',
    null,
    null,
    false,
  );
};

export const getBankDetails = async (id) => {
  return await makeApiRequest(
    `/collections/bank-show/` + id,
    'GET',
    null,
    null,
    false,
  );
};

export const getBankAccount = async (data) => {
  return await makeApiRequest(
    `/collections/bank-acount-undefined`,
    'POST',
    null,
    data,
    false,
  );
};

export const getBanksDropdown = async () => {
  return await makeApiRequest(
    `/collections/bank-dropdown`,
    'GET',
    null,
    null,
    false,
  );
};
